import { useMockUpFetch } from 'common/hooks'
import isEmpty from 'lodash/isEmpty'
import { memo, useMemo } from 'react'
import { createGetSeminarsEndpoint } from 'utils/endpoints'

import Card from '@/components/elements/card'
import SeminarGallery from '@/components/elements/gallery/seminarGallery'
import { SeminarCard, seminarMocked } from '@/components/sections/seminars/seminarCard'

const RELATED_LIMIT = 5

const RelatedSeminar = ({ seminarId, categories }) => {
  const categoriesId = categories && categories.map(({ id }) => id)

  const { state: seminars } = useMockUpFetch({
    limit: RELATED_LIMIT,
    mocked: seminarMocked,
    endpoint: createGetSeminarsEndpoint({
      limit: RELATED_LIMIT,
      sortBy: 'publish_date',
      filters: { category: categoriesId }
    })
  })

  const relatedSeminars = useMemo(
    () =>
      !isEmpty(seminars) ? seminars.filter(seminar => seminar.id !== seminarId) : [],
    [seminarId, seminars]
  )

  return (
    <div className="related-seminars-wrapper">
      {!isEmpty(relatedSeminars) ? (
        <>
          <div className="related-seminars-container-desktop">
            <SeminarGallery seminars={relatedSeminars} />
          </div>
          <div className="related-seminars-container-mobile">
            {relatedSeminars &&
              relatedSeminars.map((seminar, index) => (
                <SeminarCard
                  key={`seminar-${index}`}
                  seminar={seminar}
                  tagsScroll={false}
                  clamp
                />
              ))}
          </div>
        </>
      ) : (
        <Card />
      )}
    </div>
  )
}

export default memo(RelatedSeminar)
